import { type Dict } from 'mixpanel-browser';

interface AppContext {
  APP_URL: string
  DAL_TOKEN: string
  LEGACY_URL: string
  MIXPANEL_PROPERTIES?: Dict
  QUOTA: {
    keyword_lists: number
  }
}

declare global {
  export interface Window {
    APP_CONTEXT: AppContext;
  }
}

export function getAppContext(): AppContext {
  return window.APP_CONTEXT;
}

export function getAppUrl(): string {
  return getAppContext().APP_URL;
}
